import { InternalFilesPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import InternalCompanyDocuments from 'modules/documents/components/InternalCompanyDocuments'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ManagementDocumentsPage = () => {
  const { navigation } = useNavigation()
  const { loading, data, error } = useQuery(InternalFilesPageDocument, {})

  const canEditInternalDocuments =
    (data?.documents?._policies?.companyEditInternalDocuments.can ||
      data?.documents?._policies?.companyUseCompanyDocuments.can) ??
    false

  const canSeeInternalDocuments = data?.documents?._policies?.companySeeInternalDocuments.can

  const documentRoutesContext = {
    show: (id: string | number) =>
      navigation.files.managementDocuments.list.documentId.fullPath({ document_id: id }),
  }

  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body
        loading={loading}
        error={error}
        showHeader={false}
        authorized={canSeeInternalDocuments}
      >
        <InternalCompanyDocuments canUploadDocument={canEditInternalDocuments} />
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default ManagementDocumentsPage
